/*
  NordiskPuls NO - gave-motor
  =================================================================
  Produktbestemte gaver. Reglerne staar IKKE her - de staar paa
  produkterne i Shopify som metafelter:
    custom.gave_produkt    hvilket produkt kunden faar
    custom.gave_rabatkode  ordre-rabatten der goer den gratis
    custom.gave_maks       hvor mange pr. ordre (tomt = 1)
  En ny gave oprettes ved at udfylde felterne. Ingen kode.

  TO BETINGELSER skal begge vaere opfyldt:
    1. kunden har TAGET IMOD gaven (se np-gaveflag.js)
    2. et produkt med en gave-regel ligger i kurven

  BEMAERK at 1 ikke er "vi kender kundens mail". Det er ikke nok at
  Klaviyo genkender browseren - gaven skal vaere taget imod med et klik.
  Ellers er popup'en bare en notits om noget der allerede er sket, og saa
  mister vi baade "Gave mottatt"-eventen og chancen for at gen-tilmelde
  en kunde der var faldet af listen.

  FORHOLDET TIL NESESTRIPS-GAVEN
  Nesestrips styres af en beloebstaerskel (2.000 NOK) i
  cart-drawer-scripts.liquid og har intet med denne fil at goere. De to
  holdes fra hinanden paa _gavetype: produktgaver har den, nesestrips
  har den ikke. Uden den forskel sletter checkAutoGift() vores deksel,
  fordi den ser _is_gift paa en kurv under 2.000 kr.

  Mens motoren arbejder saettes window.isProcessingGift = true. Det er
  den samme vagt nesestrips-logikken bruger, saa de to ikke skriver til
  kurven samtidig.

  RABATKODEN ER EN TOSIDET FORPLIGTELSE:
   1. Den skal paa SAMMEN MED gaven - og gaven tages ud igen hvis koden
      ikke kan saettes. Ellers betaler kunden for en linje der staar til
      0 kr. Raekkefoelgen (gave foerst, kode bagefter) er begrundet ved
      tilfoej() laengere nede; den er rettet 28-09-2026 og maa ikke byttes
      om uden at laese den begrundelse.
   2. Den skal ryddes NAAR den sidste gave forsvinder. Ellers faar kunden
      79 kr rabat uden gave.
  Ingen af delene er oejeblikkelige, saa der er en vagt paa checkout-
  knappen nederst i filen: der kan ikke betales mens motoren arbejder.
*/
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KAMPAGNE = 'np_kampagnekode';
  var VORES_KODER = 'np_gavekoder';
  var MAERKE = 'https://cdn.shopify.com/s/files/1/0975/1658/5224/files/Design_uden_navn_-_2026-03-18T141318.852.png?v=1777384952';
  var arbejder = false;

  /* ---------- Koder vi selv har sat paa ----------

     localStorage og IKKE sessionStorage. Det er en rettelse i forhold til
     DK, hvor fejlen blev fundet 26-09-2026:

     Rabatkoden bor i Shopifys kurv-cookie og lever i DAGEVIS. Hukommelsen
     om at koden er vores laa i sessionStorage og doede naar fanen blev
     lukket. Kom kunden tilbage dagen efter og fjernede gaven, kunne
     ryddGavekoder ikke laengere genkende koden som sin egen - og saa blev
     den haengende uden gave. Hukommelsen skal leve mindst lige saa laenge
     som det den husker paa.

     Kan ikke udledes af de aktuelle regler: er udloeser-produktet fjernet
     fra kurven, er reglen ogsaa vaek - og saa ville koden blive haengende.
  */
  function huskKode(k) {
    if (!k) return;
    try {
      var l = JSON.parse(localStorage.getItem(VORES_KODER) || '[]');
      if (l.indexOf(k) === -1) { l.push(k); localStorage.setItem(VORES_KODER, JSON.stringify(l)); }
    } catch (e) {}
  }
  function voresKoder() {
    try { return JSON.parse(localStorage.getItem(VORES_KODER) || '[]'); } catch (e) { return []; }
  }

  // Der findes intet rabatkode-felt i kurv-skuffen, saa de eneste koder paa
  // sessionen er vores egne ELLER en kode fra et kampagnelink (?discount=).
  // En rydning fjerner ALLE indtastede koder, saa kampagnekoden huskes og
  // saettes paa igen. Automatiske rabatter (fx "Gratis nesestrips")
  // rammes ikke - de regner sig selv ud igen.
  (function huskKampagnekode() {
    try {
      var k = new URLSearchParams(location.search).get('discount');
      if (k) sessionStorage.setItem(KAMPAGNE, k);
    } catch (e) {}
  })();

  /* ---------- Har kunden taget imod? ---------- */

  function harTagetImod() {
    return !!(window.npGaveFlag && window.npGaveFlag.har());
  }

  // Kaldes af gave-popup'en naar kunden har afgivet sin mail.
  window.npGaveMail = function () {
    if (window.npGaveFlag) window.npGaveFlag.gem();
    synk();
  };

  function erAfvist(u) {
    return !!(window.npGaveAfvist && window.npGaveAfvist.er(u));
  }
  window.npGaveAfvis = function (u) {
    if (window.npGaveAfvist) window.npGaveAfvist.saet(u);
  };

  /* ---------- Kurv-hjaelpere ---------- */

  function post(path, body) {
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Kurv-fejl');
        return d;
      });
    });
  }

  function hentKurv() { return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }); }

  function tegnKurvOm(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inder = document.querySelector('.drawer__inner');
    var nyInder = doc.querySelector('.drawer__inner');
    if (inder && nyInder) inder.innerHTML = nyInder.innerHTML;
    ['cart-drawer', 'cart-drawer-items'].forEach(function (sel) {
      var nu = document.querySelector(sel), ny = doc.querySelector(sel);
      if (nu && ny) nu.classList.toggle('is-empty', ny.classList.contains('is-empty'));
    });
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function tegnOm(data) {
    if (data && data.sections && data.sections['cart-drawer']) {
      tegnKurvOm(data.sections['cart-drawer']);
      return Promise.resolve();
    }
    return fetch(ROOT + 'cart?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (s) { if (s['cart-drawer']) tegnKurvOm(s['cart-drawer']); });
  }

  function laesJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function laesData() { return laesJson('NPGaveData'); }
  function laesExtra() { return laesJson('NPGaveExtra') || { koder: [], vis: {}, gratis: '0' }; }

  /* ---------- Den midlertidige gavelinje ----------
     Tegnes med det samme og bliver staaende indtil kurven gen-renderes -
     enten fordi gaven landede (saa erstattes den af den rigtige linje),
     eller fordi det gik galt (saa fjernes den, se tilfoej()).
     Shopifys kurv-endpoints tager 0,5-1,8 sek hver; popup'en har lige
     sagt "vi lagger gaven i kurven", saa skal den ogsaa VAERE der.

     Teksten skal matche den rigtige gavelinje i cart-drawer.liquid.
     Staar der noget andet her, blinker linjen naar skelettet erstattes.

     Bevidst uden skraldespand: der er ikke noget bag den endnu.
     loading="eager" er ikke til pynt - theme.liquid saetter loading="lazy"
     paa alle billeder uden attribut, og drawer'en starter skjult, saa et
     lazy billede her ville aldrig blive hentet.
  */

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function fjernSkelet() {
    var s = document.querySelector('.np-gaveskelet');
    if (s) s.remove();
  }

  function visSkelet(regel, extra) {
    var v = extra.vis && extra.vis[String(regel.udloeser)];
    var tbody = document.querySelector('cart-drawer .cart-items tbody');
    if (!v || !tbody || document.querySelector('.np-gaveskelet')) return;

    var tr = document.createElement('tr');
    tr.className = 'cart-item np-gavelinje np-gaveskelet';
    tr.setAttribute('role', 'row');
    tr.setAttribute('aria-busy', 'true');
    tr.setAttribute('data-is-gift', 'true');
    tr.style.opacity = '0.55';
    tr.innerHTML =
      '<td class="cart-item__media" role="cell">' +
        (v.billede
          ? '<img class="cart-item__image" src="' + esc(v.billede) + '" alt="" width="75" height="75" loading="eager">'
          : '') +
      '</td>' +
      '<td class="cart-item__details" role="cell" colspan="3">' +
        '<div class="cart-item__info-top"><div class="cart-item__title-wrap">' +
          '<span class="cart-item__name">' + esc(v.titel) + '</span>' +
          '<div style="display:flex;align-items:center;gap:4px;margin-top:3px;">' +
            '<img src="' + MAERKE + '" alt="" width="16" height="16" loading="eager" style="object-fit:contain;flex-shrink:0;">' +
            '<span style="font-size:1.1rem;font-weight:400;color:#555;line-height:1;">Gratis gave</span>' +
          '</div>' +
          '<div class="cart-item__price-inline" style="margin-top:3px;">' +
            '<strong style="color:#1a1a1a !important;">' + esc(extra.gratis) + '</strong>' +
            (v.pris ? '<s>' + esc(v.pris) + '</s>' : '') +
          '</div>' +
        '</div></div>' +
      '</td>';
    tbody.insertBefore(tr, tbody.firstChild);
  }

  /* ---------- Rabatkoden ---------- */

  // Ligger PRAECIS denne kode paa kurven? Det er ikke nok at spoerge "er
  // der en ordrerabat" - der kan ligge andre, fx den automatiske "Gratis
  // nesestrips". For en kodebaseret rabat er title i cart.js selve koden.
  function harKoden(cart, kode) {
    var k = String(kode).trim().toLowerCase();
    return (cart.cart_level_discount_applications || []).some(function (d) {
      return String(d.title || '').trim().toLowerCase() === k;
    });
  }

  function iListen(koder, kode) {
    var k = String(kode).trim().toLowerCase();
    return (koder || []).indexOf(k) !== -1;
  }

  // Svaret ER kurven: ruten ender i /cart.js efter omdirigeringen.
  function saetKode(kode) {
    return fetch(ROOT + 'discount/' + encodeURIComponent(kode) + '?redirect=/cart.js')
      .then(function (r) { return r.json(); });
  }

  function sikrRabat(kode, koder) {
    if (!kode) return Promise.resolve(true);

    // #NPGaveExtra er renderet af SAMME kurv som gave-reglerne vi lige har
    // handlet paa. Er koden der, er den der.
    if (iListen(koder, kode)) { huskKode(kode); return Promise.resolve(true); }

    return saetKode(kode)
      .catch(function () { return hentKurv(); })
      .then(function (frisk) {
        var ok = harKoden(frisk, kode);
        if (ok) huskKode(kode);
        return ok;
      });
  }

  function ryddGavekoder() {
    var mine = voresKoder();
    if (!mine.length) return Promise.resolve(false);

    /* Her stod foer: "ligger ingen af vores koder paa kurven, er der
       intet at rydde" - maalt paa cart.discount_applications.

       Men en kode kan sidde PAA kurven uden at gaelde. Tager kunden
       Pulsen Pro ud igen, ryger gaven og dermed ogsaa kodens virkning,
       saa den forsvinder fra discount_applications - men Shopify husker
       den stadig. Naeste gang kunden lagger noget helt andet i kurven,
       slog gaverabatten til paa DET. 79 kr af huset, uden gave.

       Vi ved selv, at vi har sat koden (voresKoder), og det er nok til
       at rydde op. Den koerer kun een gang, for listen slettes lige
       nedenfor. Fundet under test 28-09-2026. */

    return post('cart/update.js', { discount: '' }).then(function () {
      try { localStorage.removeItem(VORES_KODER); } catch (e) {}
      var kamp = null;
      try { kamp = sessionStorage.getItem(KAMPAGNE); } catch (e) {}
      if (kamp) return saetKode(kamp);
    }).then(function () { return tegnOm(null); }).then(function () { return true; });
  }

  /* ---------- For mange gaver? ----------
     TO KILDER: to faner der begge lagger en gave i, eller nogen der
     skruer antallet op ad anden vej. Der klippes ned til maks ved hver
     synk. Laasen nedenfor forsoeger at undgaa det i foerste omgang.
  */
  function saetAntal(gave, antal) {
    return post('cart/change.js', { id: gave.key, quantity: antal, sections: 'cart-drawer' }).then(tegnOm);
  }

  /* Den taalte foer kun EEN linje ad gangen: "har DENNE linje flere end
     maks?". To gavelinjer med antal 1 hver - fx det samme deksel i to
     farver - blev derfor aldrig opdaget, og kunden sad med to gratis
     gaver i kurven. Nu taelles der pr. UDLOESER paa tvaers af linjer, og
     der skaeres bagfra, saa den foerste gave bliver staaende.
     Returnerer den linje der skal aendres, og hvad dens antal skal vaere
     (0 = linjen skal helt ud). Fundet live 28-09-2026. */
  function forMange(oensket, data) {
    var maksFor = {};
    oensket.forEach(function (r) { maksFor[r.udloeser] = r.maks || 1; });

    var ialt = {};
    data.gaver.forEach(function (g) { ialt[g.udloeser] = (ialt[g.udloeser] || 0) + g.antal; });

    for (var u in ialt) {
      var maks = maksFor[u];
      if (!maks || ialt[u] <= maks) continue;

      var beholdt = 0;
      for (var i = 0; i < data.gaver.length; i++) {
        var g = data.gaver[i];
        if (String(g.udloeser) !== String(u)) continue;
        var behold = Math.max(0, Math.min(g.antal, maks - beholdt));
        beholdt += behold;
        if (behold !== g.antal) return { gave: g, antal: behold };
      }
    }
    return null;
  }

  /* Tvaer-fane-laas. localStorage deles mellem faner i samme browser;
     sessionStorage goer ikke. Seks sekunder er rigeligt til en
     cart/add.js og kort nok til at en fane der doer midt i det ikke
     blokerer gaven for altid. */
  var LAAS = 'np_gave_arbejder';

  function laasTaget() {
    try {
      var t = parseInt(localStorage.getItem(LAAS) || '0', 10);
      return t > Date.now() - 6000;
    } catch (e) { return false; }
  }
  function tagLaas() { try { localStorage.setItem(LAAS, String(Date.now())); } catch (e) {} }
  function slipLaas() { try { localStorage.removeItem(LAAS); } catch (e) {} }

  /* Farvevaelgerens egen laas. np-gave-farvevaelger.js fjerner gavelinjen
     og lagger den nye farve i bagefter; i det hul findes gaven ikke i
     kurven. Den satte foer kun window.isProcessingGift, men det flag
     ejer VI ogsaa - og slukkede motoren det, fordi den blev faerdig med
     noget andet i samme oejeblik, saa synk() en kurv uden gave og lagde
     gave nummer to i. Derfor et flag mere, som kun farvevaelgeren
     skriver til.

     Det er et tidsstempel og ikke en bool: doer farveskiftet undervejs,
     giver de ti sekunder motoren lov til at overtage igen af sig selv.
     Fundet live 28-09-2026. */
  function farveskiftIGang() {
    var t = window.npFarveskift;
    return typeof t === 'number' && t > Date.now() - 10000;
  }

  /* ---------- Koden kan forsvinde uden at gaven goer det ----------
     Den anden halvdel af den tosidede forpligtelse. oprydning() daekker
     "gave vaek -> kode vaek". Det her daekker det omvendte: kunden kan
     fjerne rabatkoden i checkout med eet klik. Saa staar der stadig
     "Gratis gave - 0 kr" i kurven, men hun bliver opkraevet 79 kr.

     Kun eet forsoeg pr. kode pr. sidevisning: slaar Shopify koden fra af
     en grund vi ikke kender, skal vi ikke hamre paa /discount i en
     uendelig loekke.
  */
  var genforsoegt = {};

  function sikrKoderPaaPlads(data, extra) {
    if (arbejder || !data.gaver.length) return false;

    var regelFor = {};
    data.regler.forEach(function (r) { regelFor[r.udloeser] = r; });

    var mangler = null;
    for (var i = 0; i < data.gaver.length; i++) {
      var r = regelFor[data.gaver[i].udloeser];
      if (!r || !r.kode) continue;
      if (iListen(extra.koder, r.kode)) continue;
      if (genforsoegt[r.kode]) continue;
      mangler = r;
      break;
    }
    if (!mangler) return false;

    genforsoegt[mangler.kode] = true;
    laas(true);
    sikrRabat(mangler.kode, extra.koder)
      .then(function (ok) {
        if (!ok) {
          console.warn('[NP gave] "' + mangler.kode + '" kunne ikke saettes paa igen - gaven staar til 0 kr men koster penge');
        }
        return tegnOm(null);
      })
      .catch(function (e) { console.error('[NP gave]', e); })
      .then(function () { laas(false, true); });
    return true;
  }

  /* Faelles vagt med nesestrips-logikken i cart-drawer-scripts.liquid.
     checkAutoGift() dropper sit arbejde naar isProcessingGift er true, saa
     de to aldrig skriver til kurven samtidig.

     MEN: vores tegnOm() fyrer cart:updated MENS laasen er taget, og saa
     springer checkAutoGift over den. Uden det her ville nesestrips-gaven
     aldrig blive vurderet efter vi har roert kurven - fx naar dekslet
     bringer totalen over 2.000 kr. Derfor varsles der een gang efter at
     laasen er sluppet, og kun naar vi faktisk har aendret noget.
     varslPlanlagt forhindrer at de to motorer varsler hinanden i ring. */
  var varslPlanlagt = false;

  function laas(paa, aendrede) {
    arbejder = paa;
    // Taend frit - men sluk kun, hvis farvevaelgeren ikke selv holder flaget.
    if (paa) window.isProcessingGift = true;
    else if (!farveskiftIGang()) window.isProcessingGift = false;
    if (paa || !aendrede || varslPlanlagt) return;
    varslPlanlagt = true;
    setTimeout(function () {
      varslPlanlagt = false;
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }, 0);
  }

  // Ingen gaver tilbage? Saa maa koden heller ikke ligge der.
  function oprydning(data, extra) {
    if (data.gaver.length || arbejder) return;
    laas(true);
    ryddGavekoder()
      .catch(function (e) { console.error('[NP gave]', e); return false; })
      .then(function (ryddet) { laas(false, ryddet === true); });
  }

  /* Naar synk() maa vente paa en anden, SKAL den proeve igen.

     Maalt 28-09-2026: kunden har varer for over 2.000 kr og lagger
     Pulsen Pro i. Der kommer EEN cart:updated. 80 ms senere vil vi
     lagge dekslet i - men checkAutoGift() i cart-drawer-scripts.liquid
     har i mellemtiden taget window.isProcessingGift for at lagge
     naesestrips-gaven i. Vi returnerede, og updateCartDrawerHTML fyrer
     IKKE cart:updated bagefter. Saa kom der aldrig flere varsler, og
     dekslet blev aldrig lagt i. Det var praecis "gaven forsvinder".

     Derfor: vi giver plads, men vi slipper den ikke. Loftet paa 40
     forsoeg (16 sek.) sikrer, at et flag der haenger fast ikke saetter
     os til at banke paa i al evighed. */
  var ventTimer = null;
  var ventet = 0;

  function synk() {
    if (arbejder) return;                     // vi arbejder selv - vi kalder synk igen bagefter
    if (window.isProcessingGift || farveskiftIGang()) {
      if (ventet++ >= 40) return;
      clearTimeout(ventTimer);
      ventTimer = setTimeout(synk, 400);
      return;
    }
    ventet = 0;
    var data = laesData();
    if (!data) return;
    var extra = laesExtra();

    var oensket = data.regler.filter(function (r) { return !erAfvist(r.udloeser); });
    var gyldige = {};
    oensket.forEach(function (r) { gyldige[r.udloeser] = r; });

    // Gaver hvis udloeser er ude af kurven (eller fravalgt) skal ud.
    var forAeldede = data.gaver.filter(function (g) { return !gyldige[g.udloeser]; });
    if (forAeldede.length) {
      laas(true);
      fjern(forAeldede[0])
        .then(function () { laas(false, true); synk(); })
        .catch(function (e) { console.error('[NP gave]', e); laas(false); });
      return;
    }

    // For mange gaver klippes ned FOER der overvejes at lagge flere i.
    var forMeget = forMange(oensket, data);
    if (forMeget) {
      laas(true);
      saetAntal(forMeget.gave, forMeget.antal)
        .then(function () { laas(false, true); synk(); })
        .catch(function (e) { console.error('[NP gave]', e); laas(false); });
      return;
    }

    var harAllerede = {};
    data.gaver.forEach(function (g) { harAllerede[g.udloeser] = (harAllerede[g.udloeser] || 0) + g.antal; });
    var mangler = oensket.filter(function (r) { return (harAllerede[r.udloeser] || 0) < (r.maks || 1); });

    if (!mangler.length || !harTagetImod()) {
      // Gaven er der - men ligger koden der stadig?
      if (sikrKoderPaaPlads(data, extra)) return;
      oprydning(data, extra);
      return;
    }

    // Lagger en anden fane allerede gaven i? Saa lad vaere.
    if (laasTaget()) { setTimeout(synk, 1500); return; }

    laas(true);
    tagLaas();
    tilfoej(mangler[0], extra)
      .then(function () { slipLaas(); laas(false, true); synk(); })
      .catch(function (e) { console.error('[NP gave]', e); slipLaas(); fjernSkelet(); laas(false); });
  }

  /* ---------- RAEKKEFOELGEN ER IKKE LIGEGYLDIG ----------
     Her stod rabatkoden foerst og gaven bagefter. Mellem de to kald var
     der 1-3 sekunder hvor kurven havde 79 kr i rabat og INGEN gave. Og
     det er praecis der kunden trykker "Gaa til betaling", for popup'en
     har lige sendt hende ind i kurven med knappen "Se handlekurven".
     Naaede hun det, gik ordren igennem med rabat og uden deksel.
     Det er den mest sandsynlige forklaring paa ordre #47580 i Danmark.

     Nu: GAVEN foerst, KODEN bagefter. Saa er det vaerste der kan ske i
     vinduet, at kurven et oejeblik viser gaven til fuld pris - og den vej
     koster os ikke penge. Checkout er spaerret imens (se vagten nederst i
     filen), saa hun heller ikke kan naa at betale for den.

     Gaar koden alligevel ikke paa, tages gaven ud igen. Vi vil hellere
     mangle en gave end saelge en "gratis gave" til 79 kr.

     Bemaerk: der bedes IKKE om sections paa add-kaldet. Den HTML ville
     vaere tegnet foer rabatten kom paa, saa totalen ville vaere forkert
     indtil naeste opdatering. tegnOm(null) henter en frisk kurv til sidst.
  */
  function tilfoej(regel, extra) {
    visSkelet(regel, extra);

    return post('cart/add.js', {
      items: [{
        id: regel.variant,
        quantity: 1,
        properties: { _is_gift: 'true', _gavetype: String(regel.udloeser) }
      }]
    })
      .then(function () { return sikrRabat(regel.kode, extra.koder); })
      .then(function (ok) {
        if (ok) return tegnOm(null);
        console.warn('[NP gave] rabatkoden "' + regel.kode + '" kunne ikke saettes - gaven tages ud igen');
        return fjernVedUdloeser(regel.udloeser).then(function () { return tegnOm(null); });
      })
      .catch(function (e) {
        // Fejlede selve add-kaldet, er der ingen gave og ingen kode. Ryd
        // skelettet og lad synk() proeve igen ved naeste kurv-opdatering.
        fjernSkelet();
        throw e;
      });
  }

  // Bruges naar vi ikke har en line key - fx lige efter et add, hvor
  // kurven ikke er tegnet om endnu.
  function fjernVedUdloeser(udloeser) {
    return hentKurv().then(function (cart) {
      var l = (cart.items || []).find(function (it) {
        return it.properties && String(it.properties._gavetype) === String(udloeser);
      });
      if (!l) return;
      return post('cart/change.js', { id: l.key, quantity: 0 });
    });
  }

  function fjern(gave) {
    return post('cart/change.js', { id: gave.key, quantity: 0, sections: 'cart-drawer' })
      .then(tegnOm)
      .catch(function () {
        return hentKurv().then(function (cart) {
          var l = cart.items.find(function (it) {
            return it.properties && it.properties._gavetype == gave.udloeser;
          });
          if (!l) return;
          return post('cart/change.js', { id: l.key, quantity: 0, sections: 'cart-drawer' }).then(tegnOm);
        });
      });
  }

  /* ---------- Hvornaar koerer den ----------
     cart:updated fyres af npbSubmitBundle i main-product.liquid (l. 1117)
     og af os selv. 80 ms samler flere i traek til eet kald.

     HER STOD FOER, at updateCartDrawerHTML i cart-drawer-scripts.liquid
     ogsaa fyrer cart:updated. DET GOER DEN IKKE. Maalt 29-09-2026: tager
     kunden en vare ud med skraldespanden inde i kurven, tegnes skuffen om
     gennem updateCartDrawerHTML, og der kommer ikke een eneste besked.
     Motoren fik det aldrig at vide. Fjernede kunden Pulsen Pro, blev
     dekslet derfor liggende gratis i kurven - helt ind i checkout - saa
     laenge der var andre varer tilbage. Meldt af Emil 29-09-2026.

     Derfor kigger vi ogsaa direkte paa skuffen. Det er samme greb som
     checkAutoGift bruger til naesestrips-gaven, og netop derfor virkede
     DEN gave korrekt i samme situation, hvor vores ikke gjorde.
     planlaeg() samler alligevel flere aendringer til eet kald, og synk()
     gaar hurtigt ud igen, naar der intet er at lave - ogsaa naar det er
     vores egen tegnOm der lige har roert skuffen.
  */
  var timer = null;
  function planlaeg() { clearTimeout(timer); timer = setTimeout(synk, 80); }

  document.addEventListener('cart:updated', planlaeg);
  document.addEventListener('DOMContentLoaded', planlaeg);

  function lytPaaSkuffen() {
    if (typeof MutationObserver !== 'function') return false;
    var skuffe = document.querySelector('cart-drawer');
    if (!skuffe) return false;
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        if (m[i].addedNodes.length || m[i].removedNodes.length) { planlaeg(); return; }
      }
    }).observe(skuffe, { childList: true, subtree: true });
    return true;
  }
  // Skuffen ligger i theme.liquid, men vi kan naa at koere foer den.
  if (!lytPaaSkuffen()) document.addEventListener('DOMContentLoaded', lytPaaSkuffen);

  planlaeg();

  /* ---------- Checkout maa ikke ske midt i en gave ----------
     Selv med gaven foerst er der et oejeblik hvor kurven ikke er faerdig:
     gaven er lagt i, men rabatten er ikke paa endnu. Popup'ens knap sender
     kunden direkte ind i kurven, saa det er lige netop der hun trykker
     "Gaa til betaling".

     Vagten fanger klikket i CAPTURE-fasen paa document - altsaa foer
     knappens egen onclick naar at koere - og slipper det videre af sig
     selv saa snart motoren er faerdig. Kunden ser en kort pause, ikke en
     doed knap.

     MAKS_VENT er en sikkerhedsventil: haenger noget fast, er det bedre at
     lade hende koebe end at spaerre hende ude af sin egen kurv.
  */
  var MAKS_VENT = 6000;

  function motorenArbejder() {
    return arbejder === true || window.isProcessingGift === true || farveskiftIGang();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var knap = e.target.closest('#CartDrawer-Checkout, button[name="checkout"]');
    if (!knap) return;
    if (knap.dataset.npSlipIgennem === '1') return;   // vores eget gen-klik

    /* Gem knappens udseende FOER nogen naar at lave den om til en spinner.
       Vi sidder i capture-fasen paa document og er derfor foerst - baade
       foer vagten nedenfor og foer triggerCheckout i
       cart-drawer-scripts.liquid, som saetter spinner + disabled.
       dataset overlever bfcache, saa pageshow-handleren nederst kan give
       knappen sit rigtige udseende tilbage, naar kunden gaar tilbage fra
       checkout. Fundet live 28-09-2026. */
    if (knap.dataset.npKnapHtml === undefined && knap.innerHTML.indexOf('checkout-spinner') === -1) {
      knap.dataset.npKnapHtml = knap.innerHTML;
    }

    if (!motorenArbejder()) return;

    e.preventDefault();
    e.stopPropagation();

    // Samme spinner som triggerCheckout bruger, saa pausen ligner det den er.
    knap.innerHTML = '<span class="checkout-spinner"></span>';

    var start = Date.now();
    (function vent() {
      if (motorenArbejder() && Date.now() - start < MAKS_VENT) {
        setTimeout(vent, 120);
        return;
      }
      knap.dataset.npSlipIgennem = '1';
      knap.click();
    })();
  }, true);

  /* ---------- Tilbage fra checkout ----------
     Trykker kunden "Gaa til betaling" og gaar tilbage, genskaber browseren
     siden praecis som den laa (bfcache) - inklusive en betalingsknap der
     staar med spinner og disabled, fordi triggerCheckout satte den saadan
     lige foer hun forlod siden. Vagten ovenfor kan efterlade den samme
     tilstand. Intet nulstiller den, saa kurven ser ud som om den loader i
     al evighed. Det var praecis den fejl kunderne saa.

     Vi rydder derfor vores egne flag, giver knappen sit gemte udseende
     tilbage, og henter kurv-skuffen frisk fra serveren. Det sidste retter
     ogsaa kurven, hvis noget blev aendret undervejs i checkout.
     Fundet live 28-09-2026. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;

    arbejder = false;
    window.isProcessingGift = false;
    window.npFarveskift = 0;
    slipLaas();

    var knapper = document.querySelectorAll('#CartDrawer-Checkout, button[name="checkout"]');
    for (var i = 0; i < knapper.length; i++) {
      var b = knapper[i];
      b.disabled = false;
      b.style.opacity = '';
      if (b.dataset.npSlipIgennem) delete b.dataset.npSlipIgennem;
      if (b.dataset.npKnapHtml !== undefined && b.innerHTML.indexOf('checkout-spinner') !== -1) {
        b.innerHTML = b.dataset.npKnapHtml;
      }
    }

    tegnOm(null).catch(function (fejl) {
      console.error('[NP gave] kunne ikke hente kurven efter tilbage-navigation:', fejl);
    });
  });
})();
